const ACTIONS = {
    CREATE_REQUEST: "CREATE_INVOICE_REQUEST",
    CREATE_SUCCESS: "CREATE_INVOICE_SUCCESS",
    CREATE_FAIL: "CREATE_INVOICE_FAIL",

    FETCH_REQUEST: "FETCH_INVOICE_REQUEST",
    FETCH_SUCCESS: "FETCH_INVOICE_SUCCESS",
    FETCH_FAIL: "FETCH_INVOICE_FAIL",

    FETCH_ALL_REQUEST: "FETCH_ALL_INVOICES_REQUEST",
    FETCH_ALL_SUCCESS: "FETCH_ALL_INVOICES_SUCCESS",
    FETCH_ALL_FAIL: "FETCH_ALL_INVOICES_FAIL",

    UPDATE_REQUEST: "UPDATE_INVOICE_REQUEST",
    UPDATE_SUCCESS: "UPDATE_INVOICE_SUCCESS",
    UPDATE_FAIL: "UPDATE_INVOICE_FAIL",

    DELETE_REQUEST: "DELETE_INVOICE_REQUEST",
    DELETE_SUCCESS: "DELETE_INVOICE_SUCCESS",
    DELETE_FAIL: "DELETE_INVOICE_FAIL",

};

export default ACTIONS;
